import { render } from "./AgentDashboardPage.vue?vue&type=template&id=47d909e2&ts=true"
import script from "./AgentDashboardPage.vue?vue&type=script&lang=ts"
export * from "./AgentDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__